import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_WORK_ORDER_DISPATCH',
    method: 'GET',
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = `/api/devices/${param.device_id}/workorders/${param.id}/dispatch`;
      if (param.not_craft) {
        url += `?not_craft=${param.not_craft}`;
      }
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return data || {};
});
